import { Component, input, output } from '@angular/core';
import { PointsAdvancedSearchAction } from '@shared/types/points';

@Component({
  selector: 'idel-actions',
  templateUrl: './actions.component.html',
  styleUrl: './actions.component.scss',
})
export class ActionsComponent {
  public readonly canSave = input.required<boolean>();

  public readonly actionClick = output<PointsAdvancedSearchAction>();
}
